import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Mock authentication states for local development
  const [user, setUser] = useState({ 
    id: "local-user-id", 
    nome: "Utente Locale", 
    cognome: "Admin",
    email: "admin@local.test",
    role: "admin" 
  });
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [isLoadingAuth] = useState(false);
  const [isLoadingPublicSettings] = useState(false);
  const [authError] = useState(null);
  const [appPublicSettings] = useState({ 
    id: "local-app-id", 
    public_settings: {} 
  });

  const checkAppState = async () => {
    // Local dev: always successful
  };

  const logout = (shouldRedirect = true) => {
    console.log("Logout triggered (mocked)");
    setIsAuthenticated(false);
    setUser(null);
  };

  const navigateToLogin = () => {
    console.log("Navigate to login triggered (mocked)");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        isLoadingAuth,
        isLoadingPublicSettings,
        authError,
        appPublicSettings,
        logout,
        navigateToLogin,
        checkAppState,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
